import { Table } from 'flowbite-react';
import { Icon } from '@iconify/react';
import { ItemInput } from '../../../@types';
import LineItem from "./LineItem";
import React, {useEffect, useState} from "react";
import {LineItemMobile} from './LineItemMobile';
import { InfoCircle } from '../../../assets/icons/InfoCircle';
import PlusBoxIcon from '../../../assets/icons/PlusBoxIcon';
import { MiniCard } from '../TooltipCards/miniCards';



export interface TableColumn {
  toLowerCase(): string;
  label: string;
  key: keyof ItemInput;
  
}

export interface Props {
  columns: TableColumn[];
  items: ItemInput[];
  isSearchInput: boolean;
  addItem: () => void,
  removeItem: (index: any) => void
  updateCell: (index: number, field: string, value: string | number) => void;
  updateRow: (index: number, item: ItemInput) => void;
  isImportedToInvoice?: boolean;
}

const LineItemTable: React.FC<Props> = ({
  columns,
  items,
  isSearchInput = false,
  addItem,
  removeItem,
  updateCell,
  updateRow,
  isImportedToInvoice, 
}) => {
  const [errors, setErrors] = React.useState<string[][]>(items.map(() => []));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

const [isMobileTableExpanded, setIsMobileTableExpanded] = useState(true);
const [isMiniCardVisible, setIsMiniCardVisible] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList, observer, ) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const tableElement = document.querySelector('[data-testid="table-element"]') as HTMLElement;
          if (tableElement) {
            tableElement.style.overflowX = 'visible';
            observer.disconnect();
          }
        }
      }
    });

    observer.observe(document, { childList: true, subtree: true });

    return () => observer.disconnect();

  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const clearErrorsForIndex = (index: number) => {
    setErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = [];
      return newErrors;
    });
  };

  const updateRowAndValidate = (index: number, item: ItemInput) => {
    updateRow(index, item);
    clearErrorsForIndex(index)
  };

  // Function to update error state
  const updateError = (index: number, error: string[]) => {
    setErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = error;
      return newErrors;
    });
  };

  const validateItems = (items: ItemInput[]) => {
    const newErrors = items.map((item) => {
      const fields: string[] = [];
      if (!item.name) fields.push('name');
      if (!item.quantity || item.quantity < 0) fields.push('quantity');
      if (!item.rate || item.rate < 0) fields.push('rate');
      return fields;
    });
    setErrors(newErrors);
    return items.every(item => {
      return !(!item?.name || !item?.quantity || item.quantity < 0 || !item?.rate || item.rate < 0);
    });
  };
  const [expandedRowIndex, setExpandedRowIndex] = useState<number>(-1);
  const [isExpanded, setIsExpanded] = useState(false)
  const [expandedTableIndex, setExpandedTableIndex] = useState<number | null>(0); 
  const handleAddItem = () => {
    if (validateItems(items)) {
      setErrors([...errors, []]);
      setExpandedTableIndex((prevExpandedTableIndex) => (prevExpandedTableIndex ?? 0) + 1); 
      addItem();
    }
  }
  
  const handleInfoCircleHover = () => {
    setIsMiniCardVisible(true);
  };

  const handleInfoCircleMouseLeave = () => {
    setIsMiniCardVisible(false);
  }
    return (
      <>
        <div>
          <Table className="w-full md:w-full lg:w-full xl:w-full 2xl:w-full 3xl:w-full 4xl:w-full  text-sm text-left text-gray-500 dark:text-gray-400">
            {isMobile ? null : (
              <Table.Head className="text-white ">
                {columns?.map((column, index) => (
                  <Table.HeadCell
                  key={index}
                  className={`bg-[#044E97] md:text-white lg:text-white xl:text-white 2xl:text-white ${
                    index === columns.length - 1 ? '' : 'border-r'
                  } text-sm capitalize md:w-full lg:w-full xl:w-full 2xl:w-full 3xl:w-full 4xl:w-full  `}
                >
                    {column.label}
                  </Table.HeadCell>
                ))}
              </Table.Head>
            )}
            <br />
            <Table.Body className="divide-y">
              {items.map((item, index) => (
                <React.Fragment key={`${item.id}-${index}`}>
                  {isMobile ? (
                    <LineItemMobile
                      key={`${item.id}-${index}`}
                      index={index}
                      isSearchInput={isSearchInput}
                      item={items[index]}
                      removeItem={removeItem}
                      updateCell={updateCell}
                      updateRow={updateRowAndValidate}
                      errors={errors[index] || []}
                      updateError={updateError}
                      expanded={expandedTableIndex === index}
                      setExpanded={setExpandedTableIndex}
                    />
                  ) : (
                    <LineItem
                      key={`${item.id}-${index}`}
                      index={index}
                      columns={columns}
                      isSearchInput={isSearchInput}
                      item={items[index]}
                      removeItem={removeItem}
                      updateCell={updateCell}
                      updateRow={updateRowAndValidate}
                      errors={errors[index] || []}
                      updateError={updateError}
                    />
                  )}
                </React.Fragment>
              ))}
            </Table.Body>
          </Table>
    
          <div className={isImportedToInvoice ? "flex justify-start" : "flex justify-end"}>
            <span
              onClick={handleAddItem}
              className="flex justify-end text-[#044E97] mt-[23px] font-medium cursor-pointer lg:text-[16px] ml-[em] md:ml-[em] xl:ml-[em]  xl:mt-[0.8em] text-[12px] md:text-[14px] px-[0.8em]"
            >
              Add New Line
              <div className='xl:mt-[0.2em] biglg:mt-[0.2em] ml-[0.3em]'>
              <PlusBoxIcon/>
              </div>
             
            </span>
          </div>
        </div>
      </>
    );
    
};

export { LineItemTable };
